/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getApplication = /* GraphQL */ `
  query GetApplication($id: ID!) {
    getApplication(id: $id) {
      id
      name
      plan
      date
      nonExisting
      downgraded_products
      replaced_products
      unhealthy_products
      failed_instances
      instance_count
      instances {
        launching_order
        instance_id
        delay
        provisioned_product_id {
          value
          label
          primary_az_id
          secondary_az_id
          hostname
        }
      }
      active_node
      account_id
      dr_status
      instances_recovered
      dr_state
      primary_az_id
      secondary_az_id
      tags
      createdAt
      updatedAt
    }
  }
`;
export const listApplications = /* GraphQL */ `
  query ListApplications(
    $filter: ModelApplicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listApplications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        plan
        nonExisting
        downgraded_products
        replaced_products
        unhealthy_products
        failed_instances
        date
        instance_count
        instances {
          launching_order
          instance_id
          delay
          provisioned_product_id {
            value
            label
            primary_az_id
            secondary_az_id
            hostname
          }
        }
        active_node
        account_id
        dr_status
        instances_recovered
        dr_state
        primary_az_id
        secondary_az_id
        tags
        createdAt
        updatedAt
        deleted
      }
      nextToken
    }
  }
`;
export const getUserPermissions = /* GraphQL */ `
  query GetUserPermissions {
    getUserPermissions {
      isAdmin
      isOperator
      isReadOnly
      group
    }
  }
`;
